import global from "@/common/js/global";
let imgUrl = global.imgUrl;

export default class Organ {
  constructor({
    id,
    name,
    description,
    headerImgPath,
    imagesPath,
    orgTypeName,
    orgTypeNameList,
    orgLabels,
    totalCourseSubscriber
  }) {
    this.id = id;
    this.name = name;
    this.description = description;
    // 如果匹配没有匹配到http，就在前面添加一个imgUrl
    if (headerImgPath && headerImgPath.indexOf("http") === -1) {
      this.headerImgPath = imgUrl + headerImgPath;
    } else {
      this.headerImgPath = headerImgPath;
    }
    if (imagesPath && imagesPath.indexOf("http") === -1) {
      this.imagesPath = imgUrl + imagesPath;
    } else {
      this.imagesPath = imagesPath;
    }
    this.orgTypeName = orgTypeName;
    this.orgTypeNameList = orgTypeNameList;
    this.orgLabels = orgLabels;
    this.totalCourseSubscriber = totalCourseSubscriber;
  }
}
export function changeOrgan(organData) {
  return new Organ({
    id: organData.id,
    name: organData.orgName,
    description: organData.orgSignature,
    headerImgPath: organData.orgHeaderImgPath,
    imagesPath: organData.orgCoverImgPath,
    orgTypeName: organData.orgTypeName,
    orgTypeNameList: organData.orgTypeNameList,
    orgLabels: organData.orgLabels,
    totalCourseSubscriber: organData.totalCourseSubscriber
  });
}



// WEBPACK FOOTER //
// ./src/common/js/organ.js